import { GET } from "../config";

export const checkHealth = async () => {
  // ✅ FIXED: El endpoint correcto está en /api/shared/health/
  const response = await GET("shared/health/");
  return response.data;
};
